import moment from "moment";
import { MAX_MONTH_RANGE } from "../constant";

export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const ISO_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export function monthRangeIsMoreThanMaxMonthRange(from, to) {
    from = moment(from);
    to = moment(to);
    const monthDiff = to.diff(from, "months", true);
    return monthDiff > MAX_MONTH_RANGE;
};

/**
 * Formats a given date into the specified format.
 *
 * @param {Date|string|number} date - The date to format. Can be a Date object, a string, or a timestamp.
 * @param {string} [format=ISO_DATETIME_FORMAT] - The format string to use. Defaults to ISO_DATETIME_FORMAT.
 * @returns {string} The formatted date string.
 */
export function formatDate(date, format = ISO_DATETIME_FORMAT) {
    return moment(date).format(format);
}
